import { CategoryEntityType } from '../../components/Categories/utils';

export interface DictionaryMutationInput {
  entityIds?: string[];
  basicEventKeys?: string[];
  fieldKeys?: string[];
  categoryIds: string[];
  schema?: string;
}

export const createDictionaryMutationInput = (
  entityType: CategoryEntityType,
  entityIds: string[],
  categoryIds: string[],
  schemaId?: string,
): DictionaryMutationInput => {
  const baseInput: DictionaryMutationInput = {
    categoryIds,
  };

  if (entityType === CategoryEntityType.BasicEvent) {
    if (!schemaId) {
      throw new Error('Schema ID is required for basic events');
    }
    return {
      ...baseInput,
      basicEventKeys: entityIds,
      schema: schemaId,
    };
  }

  if (entityType === CategoryEntityType.Field) {
    if (!schemaId) {
      throw new Error('Schema ID is required for fields');
    }
    return {
      ...baseInput,
      fieldKeys: entityIds,
      schema: schemaId,
    };
  }

  return {
    ...baseInput,
    entityIds,
  };
};
